import { AxiosResponse } from "axios";
import { CommitteeMember, CommitteeMinutes, CommitteeSearchRequest } from "../../../Model/Dto/EmploymentEquity/Committee";
import { axiosCoreInstance } from "../../AxiosCoreInterceptor";
import * as ApiUrls from "./ApiUrl.Committee";

export const CommitteeService = {

    GetMember: (id: string): Promise<AxiosResponse<CommitteeMember.DtoIn>> => axiosCoreInstance.get(`${ApiUrls.Members}/${id}`),
    CreateMember: (member: CommitteeMember.DtoOut): Promise<AxiosResponse<CommitteeMember.DtoIn>> => axiosCoreInstance.post(ApiUrls.Members, member),
    UpdateMember: (member: CommitteeMember.DtoOut): Promise<AxiosResponse<CommitteeMember.DtoIn>> => axiosCoreInstance.put(ApiUrls.Members, member),
    DeleteMember: (id: string): Promise<AxiosResponse<void>> => axiosCoreInstance.delete(`${ApiUrls.Members}/${id}`),
    SearchMembers: (searchRequest: CommitteeSearchRequest): Promise<AxiosResponse<CommitteeMember.SearchResponse>> =>
        axiosCoreInstance.post(ApiUrls.SearchMembers, searchRequest),

    GetMinutes: (id: string): Promise<AxiosResponse<CommitteeMinutes.DtoIn>> => axiosCoreInstance.get(`${ApiUrls.Minutes}/${id}`),
    CreateMinutes: (member: CommitteeMinutes.DtoOut): Promise<AxiosResponse<CommitteeMinutes.DtoIn>> => axiosCoreInstance.post(ApiUrls.Minutes, member),
    UpdateMinutes: (member: CommitteeMinutes.DtoOut): Promise<AxiosResponse<CommitteeMinutes.DtoIn>> => axiosCoreInstance.put(ApiUrls.Minutes, member),
    DeleteMinutes: (id: string): Promise<AxiosResponse<void>> => axiosCoreInstance.delete(`${ApiUrls.Minutes}/${id}`),
    SearchMinutes: (searchRequest: CommitteeSearchRequest): Promise<AxiosResponse<CommitteeMinutes.SearchResponse>> =>
        axiosCoreInstance.post(ApiUrls.SearchMinutes, searchRequest),

}